export const ROLES = {
  RM: 'RM',
  CH: 'CIRCLE HEAD',
  ZM: 'ZM',
  BH: 'Business HEAD',
};

export const AUTHORIZED_EMPLOYEES = [344317, 44500];

export const COMPANY_ROLES = Object.freeze({
  SATIN_CREDITCARE_NETWORK_LTD: 100,
  TARAASHNA_FINANCIAL_SERVICES_LTD: 103, // Actual Tarashana
  SATIN_FINSERV_LTD: 105,
  SATIN_HOUSING_FINANCE_LTD: 108,
  SATIN_EMPLOYEES_WELFARE_TRUST: 109,
  TARAASHNA_EMPLOYEES_GRATUITY_SCHEME_TRUST: 110,
  SATIN_HFL: 101,
  SATIN_PROVISIONAL: 102,
  SCNL_MSME: 107,
  TARAASHNA_FINANCIAL_SERVICES_LTD_PROVISIONAL: 104,
  SATIN_GRATUITY_AND_ESOP: 106,
  TOMORROWS_INDIA: 111,
  SATIN_TECH: 112,
});
